module.exports = __webpack_public_path__ + "media/images/404-bg-01-f4478520fc9def8bdf36d9fb4d56b251.png";